import { Facebook, Youtube, Instagram, Music2 } from "lucide-react";
import Reveal, { SectionHead } from "./Reveal";

const PLATFORMS = [
  {
    icon: Youtube, name: "YouTube", priority: "Priority 1 · The Searchable Digital Pulpit",
    stat: "84% of U.S. adults use it",
    mission: "Sermons, Bible teaching, testimonies, worship clips, livestream replays, and Shorts.",
    cadence: "Weekly sermon + 2–4 Shorts",
  },
  {
    icon: Facebook, name: "Facebook", priority: "Priority 2 · The Local Community Hub",
    stat: "71% of U.S. adults use it",
    mission: "Local reach, events, announcements, prayer requests, and livestream distribution.",
    cadence: "3–5 posts weekly",
  },
  {
    icon: Instagram, name: "Instagram", priority: "Priority 3 · The Visual Discovery Channel",
    stat: "50% of U.S. adults use it",
    mission: "Reels, quote graphics, behind-the-scenes moments, volunteer spotlights, and invitations.",
    cadence: "3–5 posts weekly + Stories",
  },
  {
    icon: Music2, name: "TikTok", priority: "Priority 4 · Next-Generation Discovery",
    stat: "The fastest-growing discovery channel",
    mission: "Short-form sermon moments, youth content, and redeemed trends for a generation scrolling for hope.",
    cadence: "3–5 short videos weekly",
  },
];

export default function Platforms() {
  return (
    <section id="platforms" data-testid="platforms-section" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHead eyebrow="The Platform Stack" title="Where Your City Is Already Looking."
          sub="Churches with limited staff need a reliable content engine — not social-media exhaustion. We lead with the three platforms that matter most, and add TikTok to reach the next generation. (Pew Research, 2025)" />
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="platform-cards">
          {PLATFORMS.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.08}>
              <div className="group h-full rounded-lg border border-white/10 bg-navy-surface p-7 transition-all duration-300 hover:border-gold/60 hover:-translate-y-1.5 hover:shadow-[0_0_30px_rgba(212,175,55,0.12)]">
                <div className="flex items-center justify-between">
                  <p.icon size={30} className="text-gold" />
                  <span className="text-[10px] tracking-[0.2em] uppercase text-eblue">{p.stat}</span>
                </div>
                <h3 className="mt-5 font-display text-2xl uppercase tracking-tight text-white">{p.name}</h3>
                <p className="mt-1 text-[10px] tracking-[0.22em] uppercase text-gold/80 font-faith">{p.priority}</p>
                <p className="mt-4 text-sm text-slate-300 leading-relaxed">{p.mission}</p>
                <p className="mt-5 pt-4 border-t border-white/10 text-xs text-slate-400">
                  <span className="text-gold font-semibold">Cadence:</span> {p.cadence}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
